import styled from 'styled-components';
export const StyledIndent = styled.div.withConfig({
  componentId: "Indent__sc-1nlpw4v-0"
})(["", ";", ";", ";"], ({
  display
}) => display && `display: ${display}`, ({
  margin
}) => margin && `margin: ${margin}`, ({
  padding
}) => padding && `padding: ${padding}`);